const initialState = {
  versions: [],
  updatedCollections: [],
  projectDetail: null,
  saveCrashReportPending: false,
  saveCrashReportError: null,
  loadProjectDetailPending: false,
  loadProjectDetailError: null,
  loadProjectVersionPending: false,
  loadProjectVersionError: null,
  toggleDebugModePending: false,
  toggleDebugModeError: null,
};

export default initialState;
